import * as React from 'react';
import BuildingSpaceShuttle from '../images/business-credit-cards/buildingSpaceShuttle.svg';
import ContactSales from '../components/ContactSales';
import EmailContactSales from '../components/EmailContactSales';
import GuyCarryingPlantCounterPlants from '../images/business-credit-cards/guyCarryingPlantCounterPlants.svg';
import HandCreditCards from '../images/business-credit-cards/handCreditCards.svg';
import HandsPlant from '../images/business-credit-cards/handsPlant.svg';
import Layout from '../components/Layout';
import LightbulbManChartsWoman from '../images/business-credit-cards/lightbulbManChartsWoman.svg';
import RocketWithPlumes from '../images/business-credit-cards/rocketWithPlumes.svg';
import businessCreditCardsSplash from '../images/business-credit-cards/header-gradient.png';
import circleBlueCreditCards from '../images/icons/circle-blue-credit-cards.png';
import halfSectionGradient from '../images/business-credit-cards/half-section-gradient.png';
import halfSectionWithPattern from '../images/business-credit-cards/half-section-with-pattern.png';
import fullWidthSplitBgBlueWhite from '../images/business-credit-cards/fullWidthSplitBgBlueWhite.png';
import styled from 'styled-components';
import withStyles from '@material-ui/core/styles/withStyles';
import { graphql } from 'gatsby';
import cardOnSide from '../images/business-credit-cards/cardOnSide.png';

import WantToSeeHow from '../components/WantToSeeHow';

import PhoneVideoMP4 from '../videos/bcc.mp4';
import PhoneVideoWEBM from '../videos/bcc.webm';
import PhonePlayer from '../components/PhonePlayer';
import bccVideoThumbnail from '../images/phone/bcc.jpg';

const styles = { paper: { margin: '1em', }, };

const Section = styled.section`

	&.increase-business h3 {
		@media (${(props) => props.theme.largeUp}) {
			max-width: 950px;
		}
	}

	&.full-width-split figure.col-md-6 {
		background-color: #3d80ad;
		background-image: ${(props) => `url('${halfSectionWithPattern}')`};

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${halfSectionGradient}')`};
		}

		& .decorationBehindPhone {
			background-image: ${(props) => `url('${cardOnSide}')`};
			background-position: right center;
			padding: 0 8%;
			background-size: 37px 153px;

			@media (${(props) => props.theme.smallUp}) {
				padding: 0 11%;
				background-size: 75px 307px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				padding: 0 12.5% 0 0;
				background-size: 50px 205px;
				margin-right: 1em;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding: 0 11% 0 0;
				background-size: 75px 307px;
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.blueLeftWhiteRight {
			background-image: ${(props) => `url('${fullWidthSplitBgBlueWhite}')`};
		}
	}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		background-image: none;

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${circleBlueCreditCards}')`};
			background-repeat: no-repeat;
			background-position: right center;
			// min-height: 113px;
			width: 320px;
		}

		@media (${(props) => props.theme.largeUp}) {
			width: 400px;
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: 1em;
	text-align: center;

	@media (${(props) => props.theme.mediumUp}) {
		padding-left: 0.7em;
	}
`;
interface BusinessCreditCardsProps {
	classes: Record<string, any>;
	data: any;
}

interface BusinessCreditCardsState {
	isDialogOpen: boolean;
}

class BusinessCreditCardsPage extends React.Component<BusinessCreditCardsProps, BusinessCreditCardsState> {
	state = {
		isDialogOpen: false,
	};

	closeDialog = () => {
		this.setState({ isDialogOpen: false });
	}

	watchVideo = () => {
		this.setState({ isDialogOpen: true });
	}

	render () {
		const {
			classes,
			data,
			data: {
				site: {
					siteMetadata: { endpoint },
				},
			},
		} = this.props;

		const creditCardsHeaderContent =
			<HeaderContentArticle style={{marginTop: `0px`}}>
				<h1>Business<br />credit cards</h1>
				<p>The best way to run your<br />business credit card program.</p>
				<EmailContactSales />
			</HeaderContentArticle>
		;

		const lightbulbManChartsWomanFigure =
			<HeaderBottomContentFigure>
				<LightbulbManChartsWoman alt='Woman presenting charts, man with latop and idea ' />
			</HeaderBottomContentFigure>
		;

		return <Layout
			headerBottomContent={lightbulbManChartsWomanFigure}
			headerContent={creditCardsHeaderContent}
			headerSplashBg={businessCreditCardsSplash}
			headerSplashBgAverageColor={'#3d80ad'}
			metaDescription={"MK Decision's Business credit card origination system allows financial institutions to digitally issue business credit cards"}
			pageTitle={'Business credit card origination system'}
			skipMoney2020={true}
			BodyClass={'bccos UseCases'}
		>
			<div className='centeredWrapper'>
				<Section className='centered-text increase-business'>
					<h2>Increase business credit card volume by going digital</h2>
					{/* <h3>MK’s Business Credit Card origination system is designed for financial institutions looking to enter or grow within the business credit card market.</h3> */}
				</Section>
				<Section className='help-business row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='text-box'>
							<header>
								<HandsPlant alt='Hands nestling a seedling' />
								<h2>Help local businesses grow<br />with seamless access to credit</h2>
							</header>
							<p>Business credit cards are attractive for companies looking to earn rewards and control employee expenses. Entrepreneurs and corporate partners benefit from mobile first and compliant applications that can be completed from anywhere. The time is now to give businesses in your community easy access to credit.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6'>
						<GuyCarryingPlantCounterPlants alt='Man, woman, plants' />
					</figure>
				</Section>
			</div>
			<Section className='full-width-split full-width blueLeftWhiteRight'>
				<div className='centeredWrapper'>
					<div className='responsivePadding row row-flush'>
						<article className='col-12 col-md-6 right-on-desktop'>
							<div className='text-box'>
								<header>
									<HandCreditCards alt='Hand with Credit Cards' />
									<h2>Add multiple principles to<br />business credit card accounts</h2>
								</header>
								<p>MK’s applications are regulatory compliant and designed to handle variables in ownership and managerial registration. Easy to follow business credit card applications allow the addition of multiple beneficial owners, controlling managers, authorized signers along with authorized users and employee credit cards. </p>
							</div>
						</article>
						<figure className='col-12 col-md-6 left-on-desktop'>
							<PhonePlayer
								PhoneVideoMP4={PhoneVideoMP4}
								PhoneVideoWEBM={PhoneVideoWEBM}
							/>
						</figure>
					</div>
				</div>
			</Section>
			<div className='centeredWrapper'>
				<Section className='launching-business row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='text-box'>
							<header>
								<RocketWithPlumes alt='Rocket taking off' />
								<h2>Launching a business credit<br />card program just got easier</h2>
							</header>
							<p>Our carefully designed business loan origination platform helps you meet rising customer and regulatory compliance expectations. Enhance relationships with your business clientele through automated credit decisioning and proprietary fraud prevention products that make your business credit card program profitable and safe. The new standard in business credit card origination has arrived.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6'>
						<BuildingSpaceShuttle alt='Man and woman building a space shuttle' />
					</figure>
				</Section>
				<WantToSeeHow />
			</div>
		</Layout>;
	}
}

export default withStyles(styles)(BusinessCreditCardsPage);

export const pageQuery = graphql`
	query {
		site: site {
			siteMetadata {
				endpoint
			}
		}
  	}
`;
